import OutputNodeEditor from './OutputNodeEditorContainer'

export default OutputNodeEditor
